import { combineReducers } from "redux";

import UserReducer from "./user.reducer";
import SubscriptionReducer from "./subscription.reducer";
import LanguageChangeReducer from "./languageToggler.reducer";
import GoogleMapReducer from "./googleMap.reducer";
import SpotsReducer from "./spot.reducer";
import FreelanceInstructorReducer from "./freelanceInstructor.reducer";
import LoginReducer from "./login.reducer";
import InstructorReducer from "./instructor.reducer";
import ProfileReducer from "./profile.reducer";
import centersReducer from "./centers.reducer";
import centerReducer from "./center.reducer";
import centerInstructors from "./centerInstructors.reducer";
import centerListingReducer from "./centerListing.reducer";
import centerActivityReducer from "./centerActivity.reducer";
import CompetitionReducer from "./competitions.reducer";
import BoatTypeReducer from "./boatType.reducer";
import systemReducer from "./system.reducer";
import eventReducer from "./events.reducer";
import CourseReducer from "./course.reducer";
import dashboardReducer from "./dashboard.reducer";
import refundPolicy from "./refundPolicy.reducer";
import leaderboardReducer from "./leaderboard.reducer";
import PaymentReducer from "./payment.reducer";
import AuditLogsReducer from "./auditLogs.reducer";
import InvoiceReducer from "./invoice.reducer";

const rootReducer = combineReducers({
  SpotsReducer: SpotsReducer,
  InstructorReducer,
  LoginReducer: LoginReducer,
  UserReducer: UserReducer,
  SubscriptionReducer: SubscriptionReducer,
  FreelanceInstructorReducer: FreelanceInstructorReducer,
  LanguageChangeReducer: LanguageChangeReducer,
  GoogleMapReducer: GoogleMapReducer,
  ProfileReducer: ProfileReducer,
  centersReducer: centersReducer,
  centerReducer: centerReducer,
  centerInstructors: centerInstructors,
  centerListingReducer: centerListingReducer,
  centerActivityReducer: centerActivityReducer,
  CompetitionReducer: CompetitionReducer,
  BoatTypeReducer: BoatTypeReducer,
  systemReducer: systemReducer,
  eventReducer: eventReducer,
  CourseReducer: CourseReducer,
  dashboardReducer: dashboardReducer,
  refundPolicy: refundPolicy,
  leaderboardReducer: leaderboardReducer,
  PaymentReducer: PaymentReducer,
  AuditLogsReducer: AuditLogsReducer,
  InvoiceReducer: InvoiceReducer,
});

export default rootReducer;
